import api from '@/services/api';
import type { Pipeline, PipelineStage } from '@/modules/job/services/job.api';
import type { AgentType } from '@/modules/job/store/useJobWizard';

const BASE = '/v2/pipeline';

export type { Pipeline, PipelineStage };

export const pipelineApi = {
    getPipeline: (id: string) =>
        api.get<Pipeline>(`${BASE}/${id}`),

    updatePipeline: (id: string, data: { name?: string; stages?: Partial<PipelineStage>[] }) =>
        api.patch<Pipeline>(`${BASE}/${id}`, data),

    addStage: (id: string, data: { name: string; stageKind?: string; agentType?: string; order?: number }) =>
        api.post<Pipeline>(`${BASE}/${id}/stages`, data),

    removeStage: (pipelineId: string, stageId: string) =>
        api.delete<Pipeline>(`${BASE}/${pipelineId}/stages/${stageId}`),

    reorderStages: (id: string, stageIds: string[]) =>
        api.post<Pipeline>(`${BASE}/${id}/reorder`, { stageIds }),

    attachAgent: (pipelineId: string, stageId: string, agentType: AgentType) =>
        api.post<{ pipeline: Pipeline; agentConfig: unknown }>(`${BASE}/${pipelineId}/stages/${stageId}/attach-agent`, { agentType }),

    detachAgent: (pipelineId: string, stageId: string) =>
        api.post<Pipeline>(`${BASE}/${pipelineId}/stages/${stageId}/detach-agent`),

    linkAgentConfig: (pipelineId: string, stageId: string, agentConfigId: string) =>
        api.post<Pipeline>(`${BASE}/${pipelineId}/stages/${stageId}/link-agent-config`, { agentConfigId }),
};
